import React, { Fragment, useState } from 'react';
import AddComment from './AddComment';
import { useSelector, useDispatch } from 'react-redux';
import { convertLocaleDate } from '../../helper';
import { getReviewDetailsAction } from '../../actions/userActions';
import { useLocation } from 'react-router';
import $ from 'jquery';
import { getLastURL } from '../../helper';
import ReactPaginate from "react-paginate";
import { FormattedMessage } from 'react-intl';
import Loader from '../layout/Loader';

let count = 1;
const Rating = () => {

    const dispatch = useDispatch();
    const location = useLocation();
    const product_id = getLastURL(location);

    const { details, loading: productLoading  } = useSelector(state => state.productDetails);
    const { allReviewDetails, loading: reviewLoading } = useSelector(state => state.allReviewDetails);
    const { user } = useSelector(state => state.user);

    const isLoading = productLoading || reviewLoading;
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage, setPostPerPage] = useState(4);

    const handlePageChange = ({ selected }) => {
        dispatch(getReviewDetailsAction(product_id, null, (selected + 1)))
    }

    const pageCount = Math.ceil((allReviewDetails && allReviewDetails?.ratings?.total) / postsPerPage);

    const rating = details?.productDetails?.average_rating
                            ? Math.round(details.productDetails.average_rating)
                            : 0;

    const sellerId = details?.productDetails?.seller_id;
    const userId = user?.id;

    const canShowReviewButton =
    sellerId !== undefined &&
    sellerId !== null &&
    userId !== undefined &&
    userId !== null &&
    sellerId !== userId;
    console.log(allReviewDetails  , "==================>allReviewDetails")
    return (
        <Fragment>
            {isLoading && <Loader />}
            <section className="rating pt-4 " id="ratings-sec" >
                <div className="container-fluid">
                    <div className="rating_top d-flex justify-content-between p-3">
                        <div className="TitleBtns">
                            <h4 className="font-20 black fb mb-2"><FormattedMessage
                            id="CustomerReviews"
                            defaultMessage="Customer Reviews"
                            /></h4>
                      
                           
                            <div className="d-flex align-items-center gap-1">
                            {[1, 2, 3, 4, 5].map((star) => (
                                <i
                                key={star}
                                className="fa fa-star"
                            style={{
                                fontSize: '16px',
                                color: star <= rating ? 'rgb(0, 59, 117)' : '#dcdcdc'
                            }}
                                ></i>
                            ))}

                            <span className="ms-2 ml-2">
                                {rating} <FormattedMessage
                                        id="OutOf"
                                        defaultMessage="out of"
                                    /> 5
                            </span>
                            </div>
                           
                                <h6 className='mt-2'>{details && details.productDetails && details.productDetails.total_rating && details.productDetails.total_rating} <FormattedMessage
                                        id="ratings"
                                        defaultMessage="ratings"
                                    /></h6>
                        </div>



                    </div>


                    <div className="row">
    {/* LEFT: Rating Summary */}
    <div className="col-lg-4 col-md-12 mb-4">
        <div className="rating-summary p-3">
      
            <div className="rating-breakdown">
    {allReviewDetails?.ratingGraph?.map(star => {
        // const percent = allReviewDetails?.ratings?.breakdown?.[star] || 0;
        const percent =  star?.percentage;

        return (
            <div className="rating-row" key={star?.star}>
                <span className="rating-label">{star?.star} <FormattedMessage
                                id="Star"
                                defaultMessage="Star"
                            /></span>

                <div className="rating-bar">
                    <div
                        className="rating-bar-fill"
                        style={{ width: `${percent}%` }}
                    />
                </div>

                <span className="rating-percent">{percent}%</span>
            </div>
        );
    })}
</div>


            {canShowReviewButton && (
                <button
                className="mt-4 btn btn-outline-primary btn-theme w-100"
                data-toggle="modal"
                data-target="#comment"
                >
                <FormattedMessage
                    id="addsingleproduct.WriteAReview"
                    defaultMessage="Write a Review"
                />
                </button>
            )}
        </div>

        <div className='p-3'>
            <FormattedMessage
                    id="addsingleproduct.ReviewDescription"
                    defaultMessage=""
                />
                </div>
    </div>

    {/* RIGHT: Reviews */}
    <div className="col-lg-8 col-md-12">
        <div className="row">
            {allReviewDetails?.ratings?.data?.map((data, key) => (
                <div className="col-12 mb-3" key={key}>
                    <div className="review-card p-3">
                        <div className="d-flex justify-content-between mb-2">
                            
                            <strong>
                                {[1, 2, 3, 4, 5].map((star) => (
                                <i
                                key={star}
                                className="fa fa-star"
                            style={{
                                fontSize: '16px',
                                color: star <= data?.rating?.toFixed(0) ? 'rgb(0, 59, 117)' : '#dcdcdc'
                            }}
                                ></i>
                            ))}

                            {" "}
                            {data.rating.toFixed(1)}
                            
                                </strong>
                            <span>{convertLocaleDate(data.created_at)}</span>
                        </div>

                        <div className="mb-1">
                            <strong>{data.is_anonymous ? data.name : ""}</strong>
                        </div>

                        {data.heading && <h6>{data.heading}</h6>}
                        <p className="mb-0">{data.comment}</p>
                    </div>
                </div>
            ))}
        </div>

        <div className="table_pagination mt-3">
            <ReactPaginate
                previousLabel={<i className="icon icon-chevron_gray-left"></i>}
                nextLabel={<i className="icon icon-chevron_black"></i>}
                pageCount={pageCount}
                onPageChange={handlePageChange}
                containerClassName={"paginationBttns"}
                activeClassName={"paginationActive"}
            />
        </div>
    </div>
</div>

                </div>
            </section>
            <AddComment />
        </Fragment>
    )
}

export default Rating
